import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function FloatingCallButton() {
  return <div className="fixed bottom-24 right-4 z-40 md:hidden flex flex-col items-center gap-1" data-id="element-77">
      <a href="tel:0545188888" className="w-16 h-16 bg-[#f97316] text-white rounded-full shadow-xl flex items-center justify-center animate-bounce hover:bg-orange-600 transition-colors border-4 border-white" aria-label="Call Now" data-id="element-78">
        <PhoneIcon className="w-8 h-8 fill-current" data-id="element-79" />
      </a>
      <span className="bg-black/70 text-white text-xs px-2 py-1 rounded-md font-bold backdrop-blur-sm" data-id="element-80">
        חייגו
      </span>
    </div>;
}